import { useEffect, useState } from 'react';

const STORAGE_KEY = 'peaceflame.bannerDismissed';

/**
 * Per-session dismiss state for the PeaceFlame torch banner.
 * Backed by sessionStorage — survives intra-session navigation, clears on app
 * cold-start. SSR-safe (no sessionStorage access until effect runs).
 */
export function useTorchBannerDismissed(): {
  dismissed: boolean;
  dismiss: () => void;
} {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      setDismissed(window.sessionStorage.getItem(STORAGE_KEY) === '1');
    } catch {
      // sessionStorage can throw in private modes / sandboxed contexts — treat as not dismissed.
    }
  }, []);

  const dismiss = () => {
    setDismissed(true);
    if (typeof window === 'undefined') return;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // swallow — UI state already reflects dismiss
    }
  };

  return { dismissed, dismiss };
}
